import { render, staticRenderFns } from "./EmailIndex.vue?vue&type=template&id=4d9937ec"
import script from "./EmailIndex.vue?vue&type=script&lang=js"
export * from "./EmailIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports